<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
    <g id="Instagram">
      <g id="Icon-9" data-name="Icon">
        <path
          d="M18.437,20.937H5.564a2.5,2.5,0,0,1-2.5-2.5V5.563a2.5,2.5,0,0,1,2.5-2.5H18.437a2.5,2.5,0,0,1,2.5,2.5V18.437A2.5,2.5,0,0,1,18.437,20.937ZM5.564,4.063a1.5,1.5,0,0,0-1.5,1.5V18.437a1.5,1.5,0,0,0,1.5,1.5H18.437a1.5,1.5,0,0,0,1.5-1.5V5.563a1.5,1.5,0,0,0-1.5-1.5Z"
        />
        <path
          d="M12,16.6A4.595,4.595,0,1,1,16.6,12,4.6,4.6,0,0,1,12,16.6ZM12,8.4A3.6,3.6,0,1,0,15.6,12,3.6,3.6,0,0,0,12,8.4Z"
        />
        <circle cx="17.2" cy="6.83" r="1.075" />
      </g>
    </g>
  </svg>
</template>
